import { twMerge } from 'tailwind-merge';

import { Badge } from '@/_components';
import { type SupportStatus, SupportTicketStatus } from '@/_containers/support/shared/schemas/support-query-schema';

type TicketStatusBadgeProps = {
  status: SupportStatus;
  isOverdue?: boolean;
};

const statusConfig = {
  [SupportTicketStatus.OPEN]: {
    text: 'Open',
    className: 'bg-[#EFF6FF]! text-[#2c5cc5]! border border-[#bbdcfe]!',
  },
  [SupportTicketStatus.PENDING]: {
    text: 'Pending',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
  },
  [SupportTicketStatus.RESOLVED]: {
    text: 'Resolved',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',
  },
  [SupportTicketStatus.CLOSED]: {
    text: 'Closed',
    className: 'bg-[#f5f5f5]! text-[#6b7280]! border border-[#e5e7eb]!',
  },
  [SupportTicketStatus.WAITING_ON_CUSTOMER]: {
    text: 'Waiting on Customer',
    className: 'bg-warning-x-light text-warning dark:bg-warning-900/20 dark:text-warning-300',
  },
  [SupportTicketStatus.WAITING_ON_THIRD_PARTY]: {
    text: 'Waiting on Third Party',
    className: 'bg-info-x-light text-info dark:bg-info-x-light dark:text-info',
  },
  [SupportTicketStatus.WAITING_ON_DEVELOPER]: {
    text: 'Waiting on Developer',
    className: 'bg-info-x-light text-info dark:bg-info-x-light dark:text-info',
  },
  ['Overdue']: {
    text: 'Overdue',
    className: 'bg-[#ffecf0]! text-[#c82124]! border border-[#ffd0d6]!',
  },
};

export function TicketStatusBadge({ status, isOverdue = false }: TicketStatusBadgeProps) {
  const config =
    status === SupportTicketStatus.CLOSED
      ? statusConfig[SupportTicketStatus.CLOSED]
      : isOverdue
        ? statusConfig['Overdue']
        : statusConfig[SupportTicketStatus.OPEN];

  return (
    <Badge size="xs" className={twMerge(config.className, 'py-1.5 leading-1 text-shadow-none')}>
      {config.text}
    </Badge>
  );
}
